import ImportContactsIcon from "@mui/icons-material/ImportContacts";
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import ArchiveIcon from '@mui/icons-material/Archive';
import DeleteIcon from "@mui/icons-material/Delete";
import CreateIcon from '@mui/icons-material/Create';
import EditNoteIcon from '@mui/icons-material/EditNote';
import styles from "./TBody.module.scss";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {commonServices} from "../../../api/commonServices";
import {getDateFromISOString} from "../../../utils/getAge";
import {TranslatorValues} from "../../../const/TranslatorValues";
import {DoctorService} from "../../../api/DoctorService";
import {useDispatch, useSelector} from "react-redux";
import {ScanCompleted} from "../../../store/reducers/ScanReducer/RegistrationScanReducer";

export const TBody = ({
    paginatedInfo,
    navigateUrl,
    setAction,
    deleteUrl,
    handleUrl,
    columnOrder = undefined,
    activeRead = true,
    activeEdit = true,
    activeDelete = true,
    activeArchive = false,
    deleteTitle,
}) => {
    const navigate = useNavigate();

    const role = useSelector(state => state.login.userInfo.role)
    const roleId = useSelector(state => state.login.userInfo.id)
    const dispatch = useDispatch()

    const handleDelete = async(id) => {
        await commonServices.deleteUser(deleteUrl, id).then(res => {
                if (res){
                    toast.success(deleteTitle);
                    setAction(id)
                }
            }
        )
    };


    const handleEdit = (id) => {
        navigate(`/${handleUrl}/${id}`);
    };

    const formEdit = (id) => {
        DoctorService.getDirection(id).then(res => {
            if (res?.data){
                if (role === 'admin'){
                    dispatch(ScanCompleted({
                        credential: {
                            "status": res?.data.status,
                            "quantityMaterial": res?.data.quantityMaterial,
                            "research": res?.data.research,
                            "id": res?.data.id,
                            "type": 'change'
                        }
                    }))
                    navigate('/FormPage')
                } else {
                    if (res.data.doctorForm.doctorId !== null && res.data.doctorForm.doctorId === roleId){
                        dispatch(ScanCompleted({
                            credential: {
                                "status": res?.data.status,
                                "quantityMaterial": res?.data.quantityMaterial,
                                "research": res?.data.research,
                                "id": res?.data.id,
                                "type": 'change'
                            }
                        }))
                        navigate('/FormPage')
                    }
                }
            }
        })
    }

    const handleFullInfo = (id) => {
        if (navigate)
            navigate(navigateUrl + '/' + id)
    };

    const handlePrint = async(id) => {
        try{
            const res = await DoctorService.getSignedPdf(id, {responseType: 'blob'});

            if (res?.data){
                const blob = new Blob([res.data], {type: 'application/pdf'});
                const url = URL.createObjectURL(blob);

                const printWindow = window.open(url);
                if (printWindow){
                    printWindow.onload = () => {
                        printWindow.focus();
                        printWindow.print();
                        URL.revokeObjectURL(url); // очистить ссылку
                    };
                } else {
                    console.error('Не удалось открыть окно печати. Возможно, оно было заблокировано.');
                }
            }
        } catch(error){
            console.error('Ошибка печати PDF:', error);
        }
    };

    return (
        <tbody className={styles['pagination__body']}>
        {paginatedInfo?.map(({canBeEdited, ...item}, index) => (
            <tr key={item.id || index} className={index % 2 == 0 ? 'even-row' : 'odd-row'}
                style={!!item.isDeleted ? {opacity: 0.3, pointerEvents: 'none', padding: '15px', minHeight: '90px'} : {}}>
                {(columnOrder ?? Object.keys(item))
                    .filter(key => key !== 'isDeleted' && key in item)
                    .map((key, idx) => (
                        <th key={idx} className={key}>
                            <div className="th-text-ellipsis">
                                {item[key] !== null && item[key] !== undefined && item[key] !== ''
                                    ? ['birthDate', 'createdAt', 'updatedAt', 'operationDate'].includes(key)
                                        ? getDateFromISOString(item[key].toString())
                                        : ['roleLabel', 'status', 'outside'].includes(key)
                                            ? TranslatorValues(item[key].toString())
                                            : item[key].toString()
                                    : '---'}
                            </div>
                        </th>
                    ))}
                {(activeRead || activeDelete || activeEdit) && <th className={styles.tableSettings}>
                    {activeRead && <div onClick={() => handleFullInfo(item.id)}><ImportContactsIcon/></div>}
                    {item?.status === "finished" && <div onClick={() => handlePrint(item.id)}><LocalPrintshopIcon/></div>}
                    {item?.status === "finished" && (role === 'admin' || role === 'doctor') &&
                        <div onClick={() => formEdit(item.id)}><EditNoteIcon/></div>}
                    {(item.canBeEdited || activeEdit && !item.isDeleted) && <div onClick={() => handleEdit(item.id)}><CreateIcon/></div>}
                    {activeDelete && role === 'admin' && <div onClick={() => handleDelete(item.id)}><DeleteIcon/></div>}
                    {activeArchive && role === 'admin' && !item.isDeleted && <div onClick={() => handleDelete(item.id)}><ArchiveIcon/></div>}
                </th>}
            </tr>
        ))}
        </tbody>
    );
};